import React from 'react'

import styled from 'styled-components'
import { Checkbox, Form, Input, Segment } from 'semantic-ui-react'

const CheckboxOptions = styled.div`
  margin: 16px 0;
  color: var(--ss-link-color);

  a {
    cursor: pointer;
  }
`

export default function PermissionCheckboxGroupContent({
  handleSearchChange,
  selectAllOptions,
  clearAllOptions,
  onCheckboxChange,
  permissionAccesses,
  searchText,
}) {
  return (
    <Form.Group grouped>
      <Segment>
        <Input
          fluid
          icon="far fa-magnifying-glass"
          iconPosition="left"
          className="search"
          placeholder={searchText}
          onChange={handleSearchChange}
        />
        <CheckboxOptions>
          <a onClick={selectAllOptions}>Select all</a>
          {` · `}
          <a onClick={clearAllOptions}>Deselect all</a>
        </CheckboxOptions>
        {permissionAccesses.map((permissionAccess) => {
          return (
            <Form.Field key={permissionAccess.token}>
              <Checkbox
                name={permissionAccess.token}
                label={{
                  children: <div>{permissionAccess.name}</div>,
                }}
                checked={permissionAccess.has_permission}
                onChange={() => onCheckboxChange(permissionAccess)}
              />
            </Form.Field>
          )
        })}
      </Segment>
    </Form.Group>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/PermissionCheckboxGroup/index.js